module.exports = __webpack_public_path__ + "img/facebookWhite.9f218195.png";